/*
 * @Author: Teemo Ding
 * @Date: 2021-11-02 13:22:02
 * @LastEditTime: 2022-01-05 15:57:02
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/InternalInteraction/index.tsx
 */
import { SectionWrapper } from 'src/components/Layouts';
//import css from './css.module.less';
import _ from 'lodash';
import { Timeline } from 'antd';
import React, { Fragment, useState } from 'react';
import css from './css.module.less';
import { Icon } from '@/src/tools/icon';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  handleOnFormatStoreDate,
  handleOnFormatStoreTime,
} from '@/src/tools/tools';
const InternalInteraction = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { interaction = [] } = props;
  const [check, setCheck] = useState(-1);

  const activitiesList = (interaction || []).map((activity) => ({
    ...activity,
    date: handleOnFormatStoreDate(activity.timestamp) || '',
    time: handleOnFormatStoreTime(activity.timestamp) || '',
  }));

  const formatActivitiesList = _.groupBy(activitiesList, 'date');
  // console.log(Object.entries(formatActivitiesList));
  const handlePanelClick = (index) => {
    if (check == index) {
      setCheck(-1);
    } else {
      setCheck(index);
    }
  };
  return (
    <SectionWrapper
      title={getI18n(
        'allOrders.orderDetail.internalInteraction_return_SectionWrapper_title',
      )}
      containerClassName={css.containerClassName}>
      <Timeline className={css.activityTimeline}>
        {Object.entries(formatActivitiesList).map((item, itemIndex) => (
          <Fragment key={itemIndex}>
            <Timeline.Item className={css.noTimelineItem} dot={<div></div>}>
              <span className={css.timelineTitle}>{item[0]}</span>
            </Timeline.Item>
            {(item[1] || []).map((list, listIndex) => (
              <Timeline.Item key={listIndex}>
                <div>
                  <p
                    className={
                      (list.items || []).length ? css.cursor : css.text
                    }
                    onClick={(e) =>
                      (list.items || []).length
                        ? handlePanelClick(listIndex)
                        : void 0
                    }>
                    {list.remark}{' '}
                    {(list.items || []).length ? (
                      <Icon
                        type={check == listIndex ? 'icondown1' : 'iconright'}
                        className={css.iconDown}
                      />
                    ) : null}
                  </p>
                  {check == listIndex && (
                    <div className={css.panelContain}>
                      {(list.items || []).map((item, index) => (
                        <div className={css.panel} key={index}>
                          <span>{item.name}</span>
                          <span>{item.value}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <span>{list.time}</span>
              </Timeline.Item>
            ))}
          </Fragment>
        ))}
      </Timeline>
    </SectionWrapper>
  );
};
export default InternalInteraction;
